import { __extends } from "tslib";
import { deserializeAws_restJson1_1GetJourneyExecutionMetricsCommand, serializeAws_restJson1_1GetJourneyExecutionMetricsCommand } from "../protocols/Aws_restJson1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetJourneyExecutionMetricsCommand = /** @class */ (function (_super) {
    __extends(GetJourneyExecutionMetricsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetJourneyExecutionMetricsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetJourneyExecutionMetricsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetJourneyExecutionMetricsCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1_1GetJourneyExecutionMetricsCommand(input, context);
    };
    GetJourneyExecutionMetricsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1_1GetJourneyExecutionMetricsCommand(output, context);
    };
    return GetJourneyExecutionMetricsCommand;
}($Command));
export { GetJourneyExecutionMetricsCommand };
//# sourceMappingURL=GetJourneyExecutionMetricsCommand.js.map